'use strict';

angular.module('obex')
    .factory('authInterceptor', authToken => {
      return {
        request: config => {
          const token = authToken.getToken();

          if (token) {
            config.headers.Authorization = 'Bearer ' + token;
          }

          return config;
        },

        response: response => response,
      };
    });



// WEBPACK FOOTER //
// ./client/js/services/authInterceptor.factory.js